export default class Controller {
    constructor() {
        this.isInit = false;
        this.callbacks = {};
    }

    init(App, controllerName, elements, dataset) {
        this.App = App;
        this.controllerName = controllerName;
        this.data = dataset || {};

        for (let prop in elements) {
            this[prop] = elements[prop];
        }
    }

    afterInit() {

    }

    run() {
        if (!this.isInit) {
            this.afterInit();
            this.isInit = true;
        }
    }

    replace(string, params) {
        for (let key in params) {
            string = string.replaceAll('{' + key + '}', params[key]);
        }

        return string;
    }

    createElementFromHTML(htmlString) {
        let div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        return div.firstChild;
    }

    refresh() {
        this.App.refresh(this.controllerName);
    }
}